module.exports = __webpack_public_path__ + "static/img/40015 (3).0985774.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40015 (3).webp
// module id = Ahg/
// module chunks = 14